import { z } from "zod";

/**
 * Variables de entorno validadas al arrancar la app. Falla temprano
 * (hard crash) si falta algo crítico — mejor que un error críptico en
 * runtime dentro de un componente.
 *
 * En Vite, las env vars públicas deben empezar con `VITE_` y son
 * inlineadas en build time. Nunca poner secrets acá.
 */
const EnvSchema = z.object({
  VITE_API_BASE_URL: z.string().url({
    message: "VITE_API_BASE_URL debe ser una URL válida (ej. https://xxx.supabase.co/functions/v1)",
  }),
  VITE_SUPABASE_ANON_KEY: z.string().min(20, {
    message: "VITE_SUPABASE_ANON_KEY parece inválido (muy corto)",
  }),
  VITE_ENVIRONMENT: z.enum(["development", "staging", "production"]).default("development"),
});

const parsed = EnvSchema.safeParse(import.meta.env);

if (!parsed.success) {
  console.error("❌ Variables de entorno inválidas:", parsed.error.flatten().fieldErrors);
  throw new Error("Configuración de entorno inválida. Revisa tu `.env` contra `.env.example`.");
}

export const ENV = parsed.data;

export type Environment = z.infer<typeof EnvSchema>;
